import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { ComponentBase, RentalInfo, RentalStatus } from 't4core';
import { RentalDialog } from '../../dialogs/rentaldialog/rentaldialog';
import { SmsDialog } from '../../dialogs/SmsDialog/SmsDialog';
import { CallDialog } from '../../dialogs/CallDialog/CallDialog';


@Component({
    selector: 't4-booking-link',
    templateUrl: './bookingLink.html',
    styleUrls: ['./bookingLink.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class T4BookingLink extends ComponentBase {
  private _bookingId: number;
  public get bookingId(): number { return this._bookingId; }
    @Input() public set bookingId(value: number|null) {
        if (!value) return;

        var val = parseInt(value.toString());
        if (this._bookingId != val) {
            this._bookingId = val;
            this.booking = undefined;
        }
    };

    @Output() public mouseOver = new EventEmitter<RentalInfo>();
    @Output() public mouseOut = new EventEmitter<RentalInfo>();
    @Output() public clicked = new EventEmitter<RentalInfo>();

    @Input() public preventDefault: boolean = false;

    public booking: RentalInfo;
    public isLoading: boolean = false;
    public displayTooltip: boolean = false;
    public hidingTooltip: boolean = false;

    constructor(public ChangeDetector: ChangeDetectorRef) {
        super();
    }

    private loadBooking() {
        this.isLoading = true;

        this.Api.get<RentalInfo>("Rental/GetRentalInfo", { bookingId: this._bookingId }).then(x => {
            this.booking = x;
            this.mouseOver.emit(this.booking);
            this.ChangeDetector.markForCheck();
        });
    }

    public show() {
        this.hidingTooltip = false;
        this.displayTooltip = true;
        if (!this.booking) {
            this.loadBooking();
        } else {
            this.mouseOver.emit(this.booking);
        }
    }

    public hide() {
        this.hidingTooltip = true;
        setTimeout(() => {
            if (this.hidingTooltip) {
                this.displayTooltip = false;
                this.mouseOut.emit(this.booking);
            }
        }, 100);
    }

  public async open() {
    if (!this.preventDefault) {
      if (!this.Settings.isInAny(['OneWayAdmin', 'Admin'], true) && !this.booking.IsOneWay && this.booking.PickupLocationId != this.Settings.clientSettings.RentalLocationId) {
        this.UI.alert("Turbo.Core.BookingLink.OpenBookingFailed.Headline", "Failed!", "Turbo.Core.BookingLink.OpenBookingFailed.Message", "This booking can't be opened from your location.");
        return;
      }
      this.booking = await RentalDialog.openBooking(this.Dialog, this._bookingId);
      this.mouseOut.emit(this.booking);
      this.clicked.emit(this.booking);
    }
    else this.clicked.emit()
         
   }

    public sendSms() {
        this.Dialog.open(SmsDialog, { data: { rentalId: this.booking.Id, receiver: this.booking.Customer.Firstname, message: "" } });
    }

    public confirmBooking() {
        if (this.Settings.isInAny(['OneWayAdmin']) && this.booking.IsOneWay && this.booking.Status == 0) {
            this.UI.confirm("Turbo.Core.BookingLink.ConfirmConfirm.Headline", "Are you sure that you want to confirm this booking?", "Turbo.Core.BookingLink.ConfirmConfirm.Message", "Confirmations are normally carried out automatically. Make sure that all confirmed bookings will have a trailer. Continue?", null, null).then(y => {
                if (!y) return;

                this.Api.get<boolean>("Rental/Confirm", { booking: this._bookingId }).then(x => {
                    if (x) {
                        this.booking.Status = RentalStatus.ReservedAndBound;
                        this.UI.alert("Turbo.Core.BookingLink.BookingConfirmed.Headline", "Success!", "Turbo.Core.BookingLink.BookingConfirmed.Message", "This booking has been confirmed.");
                    }
                });
            });
        }
    }

    public callCustomer() {
        this.UI.confirm("Turbo.Core.BookingLink.ConfirmCall.Headline", "Are you sure?", "Turbo.Core.BookingLink.ConfirmCall.Message", "Place a call to {0}?", null, [ this.booking.Customer.Firstname ]).then(x => {
            if (x == true) {
                this.Dialog.open(CallDialog, { data: { rentalId: this.booking.Id, receiver: this.booking.Customer.Firstname } });
            }
        });
    }
}
